import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 25px 0 0 18px;
  width: 100%;
  height: 100%;
`;
export const Interface = styled.div`
  position: relative;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: solid 10px ${(props) => props.color};
  min-height: 540px;
`;

export const Inputs = styled.div`
  display: flex;
  margin: 0 0 5px;
`;

export const ZoneLabel = styled.div`
  color: #fff;
  white-space: nowrap;
  line-height: 40px;
  /* width: 260px; */
  text-align: left;
`;

export const Block = styled.div`
  margin: 0 0 40px;
  color: #fff;
`;

export const Title = styled.div`
  margin: 0 0 10px;
  font-size: 1.3em;
`;

export const Input = styled.div`
  margin: 0 20px 0 0;
`;
